import React from 'react';
import { Box, CardActions, CardHeader, Container, Typography } from '@mui/material';
import PrimaryButton from '../../common/components/PrimaryButton';
import useDataExport from '../hooks/useDataExport';
import CardWithBoxShadow from '../../common/components/CardWithBoxShadow';
import ConfirmDialog from '../../common/components/ConfirmDialog';

export default function DataExport() {
    const {
        exportUserData,
        exportMedia,
        handleClose,
        handleDownload,
        handleMediaDownload,
        isLoading,
        isMediaLoading,
        isModalOpen,
        isMediaModalOpen,
        errorMessage,
        mediaErrorMessage
    } = useDataExport();

    return (
        <Box className="outer-container with-nav">
            <Container maxWidth="lg">
                <Box className="management-header">
                    <header>
                        <h1 className="title">Export Data</h1>
                    </header>
                </Box>
                <CardWithBoxShadow data-testid="card" classes={{ root: 'form-card card current-plan' }}>
                    <CardHeader
                        title="Download your training data, messages, etc."
                        classes={{
                            root: 'padding-desktop',
                            title: 'card-title'
                        }}
                    />
                    {isLoading && (
                        <Box sx={{ textAlign: 'center', p: 2 }}>
                            <img
                                src="https://media.tenor.com/X30cWEgGWDsAAAAj/abster-abstract.gif"
                                alt="Loading"
                                style={{ maxWidth: '100%' }}
                            />
                            <Typography>
                                Just like your gains, this might take a while. Please stay on this screen.
                            </Typography>
                        </Box>
                    )}
                    {!isLoading && errorMessage && (
                        <Box sx={{ textAlign: 'left', p: 4 }}>
                            <Typography color="error">{errorMessage}</Typography>
                            <a
                                href="https://support.trainheroic.com/hc/en-us"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Please contact the TrainHeroic Support Team for assistance.
                            </a>
                        </Box>
                    )}
                    <CardActions classes={{ root: 'action-container' }}>
                        <Box className="action-buttons-container">
                            <PrimaryButton onClick={exportUserData} disabled={isLoading || isMediaLoading}>
                                {isLoading ? 'Exporting...' : 'Export User Data'}
                            </PrimaryButton>
                        </Box>
                    </CardActions>
                </CardWithBoxShadow>

                <ConfirmDialog
                    title="Export Complete"
                    subtext="Your user data export is ready. Click the button below to download your data."
                    isOpen={isModalOpen}
                    handleClose={handleClose}
                    proceed={handleDownload}
                    proceedButtonText="Download Zip File"
                />

                <CardWithBoxShadow data-testid="card" classes={{ root: 'form-card card current-plan' }}>
                    <CardHeader
                        title="Download your media files"
                        classes={{
                            root: 'padding-desktop',
                            title: 'card-title'
                        }}
                    />
                    {isMediaLoading && (
                        <Box sx={{ textAlign: 'center', p: 2 }}>
                            <img
                                src="https://media.tenor.com/X30cWEgGWDsAAAAj/abster-abstract.gif"
                                alt="Loading"
                                style={{ maxWidth: '100%' }}
                            />
                            <Typography>
                                Just like your gains, this might take a while. Please stay on this screen.
                            </Typography>
                        </Box>
                    )}
                    {!isMediaLoading && mediaErrorMessage && (
                        <Box sx={{ textAlign: 'left', p: 4 }}>
                            <Typography color="error">{mediaErrorMessage}</Typography>
                            <a
                                href="https://support.trainheroic.com/hc/en-us"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Please contact the TrainHeroic Support Team for assistance.
                            </a>
                        </Box>
                    )}
                    <CardActions classes={{ root: 'action-container' }}>
                        <Box className="action-buttons-container">
                            <PrimaryButton onClick={exportMedia} disabled={isMediaLoading || isLoading}>
                                {isMediaLoading ? 'Exporting...' : 'Export Media'}
                            </PrimaryButton>
                        </Box>
                    </CardActions>
                </CardWithBoxShadow>

                <ConfirmDialog
                    title="Export Complete"
                    subtext="Your media export is ready. Click the button below to download your data."
                    isOpen={isMediaModalOpen}
                    handleClose={handleClose}
                    proceed={handleMediaDownload}
                    proceedButtonText="Download Zip File"
                />
            </Container>
        </Box>
    );
}
